import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs';
import { Camera } from '../../../camera/service/camera-api.service.model';
import { RawFilters } from '../../../camera/service/camera-api.service.types';
import { HorusApiService } from '../service/horus-api.service';
import {
  FetchCamerasHorus,
  SaveRawFiltersHorus,
  UpdateCameraState,
} from './horus.actions';

export interface HorusStateModel {
  cameras: Camera[];
  rawFilters: RawFilters | undefined;
}

@State<HorusStateModel>({
  name: 'HorusState',
  defaults: {
    cameras: [],
    rawFilters: undefined,
  },
})
@Injectable()
export class HorusState {
  horusApiService = inject(HorusApiService);

  @Action(FetchCamerasHorus)
  FetchCameras(ctx: StateContext<HorusStateModel>, action: FetchCamerasHorus) {
    return this.horusApiService.getCameras(action.filters).pipe(
      tap((cameras) => {
        ctx.patchState({
          cameras,
        });
      }),
    );
  }

  @Action(SaveRawFiltersHorus)
  SaveRawFilters(
    ctx: StateContext<HorusStateModel>,
    action: SaveRawFiltersHorus,
  ) {
    return ctx.patchState({
      rawFilters: action.rawFilters,
    });
  }

  @Action(UpdateCameraState)
  UpdateCameraState(
    ctx: StateContext<HorusStateModel>,
    action: UpdateCameraState,
  ) {
    const cameras = [...ctx.getState().cameras];
    const cameraindex = cameras.findIndex(
      (camera) => camera.id === action.cameraId,
    );
    if (cameraindex > -1) {
      cameras[cameraindex].state = action.state;
    }
    return ctx.patchState({
      cameras: cameras,
    });
  }

  @Selector()
  static getCameras(state: HorusStateModel): Camera[] {
    return state.cameras;
  }

  @Selector()
  static getRawFilters(state: HorusStateModel): RawFilters | undefined {
    return state.rawFilters;
  }
}
